import { InitiativeManagementState, initiativeManagementInitialState } from './State'

import {
  SET_INITIATIVE_DATA,
  SET_IS_LOADING_INITIATIVE,
  SET_GRADUATE_GPA_VALUE,
  SET_UNDERGRADUATE_GPA_VALUE,
  SET_QUESTION_ANSWER,
  SET_IS_SUBMITTING_INITIATIVE,
  SET_IS_WITHDRAWING,
  RESET,
  SET_DOES_NOT_APPLY_GRADUATE_GPA,
  SET_DOES_NOT_APPLY_UNDERGRADUATE_GPA,
  InitiativeManagementAction
} from './Actions'

function initiativeManagementReducer(
  state: InitiativeManagementState,
  action: InitiativeManagementAction
): InitiativeManagementState {
  switch (action.type) {
    case SET_INITIATIVE_DATA:
      return Object.assign({}, state, action.payload, { isLoadingInitiative: false })
    case SET_IS_LOADING_INITIATIVE:
      return Object.assign({}, state, { isLoadingInitiative: action.payload })
    case SET_IS_SUBMITTING_INITIATIVE:
      return Object.assign({}, state, { isSubmittingInitiative: action.payload })
    case SET_GRADUATE_GPA_VALUE:
      return Object.assign({}, state, {
        answers: {
          ...state.answers,
          gpaValues: {
            ...state.answers.gpaValues,
            graduateGpa: action.payload
          }
        }
      })
    case SET_UNDERGRADUATE_GPA_VALUE:
      return Object.assign({}, state, {
        answers: {
          ...state.answers,
          gpaValues: {
            ...state.answers.gpaValues,
            undergraduateGpa: action.payload
          }
        }
      })
    case SET_QUESTION_ANSWER:
      return Object.assign({}, state, {
        answers: {
          ...state.answers,
          questions: {
            ...state.answers.questions,
            ...(action.payload as { [key: number]: { answer?: string; choices?: number[] } })
          }
        }
      })
    case SET_IS_WITHDRAWING:
      return Object.assign({}, state, {
        isWithdrawing: action.payload
      })
    case RESET:
      return initiativeManagementInitialState
    case SET_DOES_NOT_APPLY_GRADUATE_GPA:
      return Object.assign({}, state, {
        answers: {
          ...state.answers,
          gpaValues: {
            ...state.answers.gpaValues,
            doesNotApplyForGraduateGpa: action.payload
          }
        }
      })
    case SET_DOES_NOT_APPLY_UNDERGRADUATE_GPA:
      return Object.assign({}, state, {
        answers: {
          ...state.answers,
          gpaValues: {
            ...state.answers.gpaValues,
            doesNotApplyForUndergraduateGpa: action.payload
          }
        }
      })
    default:
      return state
  }
}

export default initiativeManagementReducer
